import { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router'
import { Text } from '../text/Text.tsx'
import { Button } from '../button/Button.tsx'
import { StatusPage } from './StatusPage.tsx'
import styles from './StatusPage.module.css'

const MESSAGES = [
  "Our devs are in queue. Estimated wait time: Soon\u2122",
  "This feature is still in champion select.",
  "Patch notes loading... this one's gonna be huge.",
  "The lobby's being set up. Warm up while you wait.",
  "Our team is grinding ranked to unlock this feature.",
  "Currently in the loading screen. Almost there.",
  "Feature is buffering. Have you tried getting good?",
  "AFK for maintenance. Be right back.",
  "Waiting for the surrender vote to fail so we can finish building this.",
]

export interface ComingSoonProps {
  featureName?: string
  homePath?: string
  onGoHome?: () => void
}

export function ComingSoon({ featureName, homePath = '/', onGoHome }: ComingSoonProps) {
  const navigate = useNavigate()
  const [messageIndex, setMessageIndex] = useState(() =>
    Math.floor(Math.random() * MESSAGES.length)
  )
  const [fadeKey, setFadeKey] = useState(0)

  const cycleMessage = useCallback(() => {
    setMessageIndex(prev => (prev + 1) % MESSAGES.length)
    setFadeKey(prev => prev + 1)
  }, [])

  useEffect(() => {
    const interval = setInterval(cycleMessage, 4000)
    return () => clearInterval(interval)
  }, [cycleMessage])

  const displayText = featureName ?? 'SOON\u2122'

  return (
    <StatusPage>
      <div className={styles.statusLabel}>Incoming Transmission</div>
      <div
        className={featureName ? styles.glitchSm : styles.glitch}
        data-text={displayText}
      >
        {displayText}
      </div>
      <Text as="h1" size="xl" weight="bold" className={styles.title}>
        Under Construction
      </Text>
      <Text
        key={fadeKey}
        as="p"
        size="sm"
        muted
        className={`${styles.subtitle} ${styles.subtitleFade}`}
      >
        {MESSAGES[messageIndex]}
      </Text>
      <div className={styles.actions}>
        <Button
          variant="primary"
          size="sm"
          onClick={onGoHome ?? (() => navigate(homePath))}
        >
          Return to Base
        </Button>
      </div>
      <Text as="p" size="xs" muted className={styles.hint}>
        Pro tip: Refreshing won&apos;t make it come faster.
      </Text>
    </StatusPage>
  )
}
